import {
    FORM_KPI_LCR_LIST,
    FORM_KPI_LCR_LIST_SUCCESS,
    FORM_KPI_LCR_LIST_ERROR,
    FORM_KPI_LCR_PAGE_SET,
    FORM_KPI_LCR_SEARCH_SET,
    FORM_KPI_LCR_SEARCH_CHANGE,
    FORM_KPI_LCR_ADD_MODAL_SET,
    FORM_KPI_LCR_ADD,
    FORM_KPI_LCR_ADD_SUCCESS,
    FORM_KPI_LCR_ADD_ERROR,
    FORM_KPI_LCR_ADD_CHANGE,
    FORM_KPI_LCR_ADD_SET,
    FORM_KPI_LCR_PROJECT,
    FORM_KPI_LCR_PROJECT_SUCCESS,
    FORM_KPI_LCR_PROJECT_ERROR,
    FORM_KPI_LCR_ARTICLE_TYPE,
    FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS,
    FORM_KPI_LCR_ARTICLE_TYPE_ERROR,
    FORM_KPI_LCR_ACQUISITION_TYPE,
    FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS,
    FORM_KPI_LCR_ACQUISITION_TYPE_ERROR,
    FORM_KPI_LCR_CONTRACT_TYPE,
    FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS,
    FORM_KPI_LCR_CONTRACT_TYPE_ERROR,
    FORM_KPI_LCR_COUNTRY_PROJECT,
    FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS,
    FORM_KPI_LCR_COUNTRY_PROJECT_ERROR,
    FORM_KPI_LCR_COUNTRY_LIST,
    FORM_KPI_LCR_COUNTRY_LIST_SUCCESS,
    FORM_KPI_LCR_COUNTRY_LIST_ERROR

} from '../actions';

const INIT_STATE = {
    loading: true,
    list: {
        data: [],
        loading: true,
        page: {
            current: 1,
            rows: 10
        }
    },
    project: {
        data: [],
        loading: true,
        message: ''
    },
    articletype: {
        data: [],
        loading: true,
        message: ''
    },
    contracttype: {
        data: [],
        loading: true,
        message: ''
    },
    acquisitiontype: {
        data: [],
        loading: true,
        message: ''
    },
    countryproject: {
        data: [],
        loading: true,
        message: ''
    },
    countrylist: {
        data: [],
        loading: true,
        message: ''
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            idgeo_country: '',
            idarticle_type: '',
            idacquisition_type: '',
            idcontract_type:''
        },
        value: {
            idgeo_country: '',
            idarticle_type: '',
            idacquisition_type: '',
            idcontract_type: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FORM_KPI_LCR_LIST:
            return {
                ...state,
                list: {
                    ...state.list,
                    data: [],
                    loading: true
                }
            }
        case FORM_KPI_LCR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case FORM_KPI_LCR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case FORM_KPI_LCR_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                },
                log: []
            }
        case FORM_KPI_LCR_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case FORM_KPI_LCR_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    init: false,
                    value: action.payload,
                }
            }
        case FORM_KPI_LCR_ADD_CHANGE:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload,
                        new: {
                            ...state.add.data.new,
                            ...action.payload
                        }
                    }
                }
            }
        case FORM_KPI_LCR_ADD_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: action.payload
                }
            }
        case FORM_KPI_LCR_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case FORM_KPI_LCR_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: true
                }
            }
        case FORM_KPI_LCR_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case FORM_KPI_LCR_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_PROJECT:
            return {
                ...state,
                init: false,
                project: {
                    ...state.project,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_PROJECT_SUCCESS:
            return {
                ...state,
                project: {
                    ...state.project,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_PROJECT_ERROR:
            return {
                ...state,
                project: {
                    ...state.project,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_ARTICLE_TYPE:
            return {
                ...state,
                init: false,
                articletype: {
                    ...state.articletype,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS:
            return {
                ...state,
                articletype: {
                    ...state.articletype,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_ARTICLE_TYPE_ERROR:
            return {
                ...state,
                articletype: {
                    ...state.articletype,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_ACQUISITION_TYPE:
            return {
                ...state,
                init: false,
                acquisitiontype: {
                    ...state.acquisitiontype,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS:
            return {
                ...state,
                acquisitiontype: {
                    ...state.acquisitiontype,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_ACQUISITION_TYPE_ERROR:
            return {
                ...state,
                acquisitiontype: {
                    ...state.acquisitiontype,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_CONTRACT_TYPE:
            return {
                ...state,
                init: false,
                contracttype: {
                    ...state.contracttype,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS:
            return {
                ...state,
                contracttype: {
                    ...state.contracttype,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_CONTRACT_TYPE_ERROR:
            return {
                ...state,
                contracttype: {
                    ...state.contracttype,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_COUNTRY_PROJECT:
            return {
                ...state,
                init: false,
                countryproject: {
                    ...state.countryproject,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS:
            return {
                ...state,
                countryproject: {
                    ...state.countryproject,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_COUNTRY_PROJECT_ERROR:
            return {
                ...state,
                countryproject: {
                    ...state.countryproject,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case FORM_KPI_LCR_COUNTRY_LIST:
            return {
                ...state,
                init: false,
                countrylist: {
                    ...state.countrylist,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case FORM_KPI_LCR_COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                countrylist: {
                    ...state.countrylist,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case FORM_KPI_LCR_COUNTRY_LIST_ERROR:
            return {
                ...state,
                countrylist: {
                    ...state.countrylist,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        default:
            return { ...state };
    }
};